/**
 * Dashboard for users.role === btybMarketer.
 * The only application is the city CPM auction (BTYB).
 */

import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import Settings from "components/dashboard/Settings";
import BtybAuctionPage from "pages/dashboard/btyb/BtybAuctionPage";
import DashboardLayout from "components/dashboard/DashboardLayout";
import HomePage from "pages/dashboard/HomePage";
import { useAuth } from "hooks/useAuth";

const BtybMarketerRoutes = () => {
  const { user, subscription } = useAuth();

  return (
    <DashboardLayout>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/btyb" element={<BtybAuctionPage />} />
        <Route
          path="/settings"
          element={<Settings uid={user?.uid} subscription={subscription} />}
        />
        <Route path="*" element={<Navigate to="/dashboard/btyb" replace />} />
      </Routes>
    </DashboardLayout>
  );
};

export default BtybMarketerRoutes;
